<div id="spinner-container" class="spinner-container" *ngIf="loading">
  <mat-spinner [diameter]="24"></mat-spinner>
</div>
<section *ngIf="domain" fxLayout="row" fxHide.xs (click)="openDomainPicker()" class="domain-picker-trigger">
  <mat-icon class="domain-header-logo">business</mat-icon>
  <div class="domain-header">{{domain}}</div>
</section>
<section *ngIf="domain" fxHide fxShow.xs>
  <mat-icon class="domain-header-logo" (click)="openDomainPicker()">business</mat-icon>
</section>
